export interface EntriesInterface {
  usedAt: string;
  line: string;
  lineColor: string;
  type: number;
}

export interface EntriesFormatedInterface {
  hour: number;
  entry: {
    total: number;
  };
  exit: {
    total: number;
  };
}

export interface ContributionByLineInterface {
  hour: number;
  line: string;
  value: number;
}

class generateGraphData {
  // format data from charts
  static groupByHour(entries: EntriesInterface[]) {
    const result: any = {};
    entries.forEach((item) => {
      const itemDate = new Date(item.usedAt);
      const hour = itemDate.getHours();

      const dataHour = result[hour] || {
        hour,
        entry: {
          total: 0,
        },
        exit: {
          total: 0,
        },
      };

      if (item.type === 0) {
        // Entry
        dataHour.entry.total++; // eslint-disable-line no-plusplus
        if (dataHour.entry[item.line]) {
          dataHour.entry[item.line]++; // eslint-disable-line no-plusplus
        } else {
          dataHour.entry[item.line] = 1;
        }
      } else {
        // Exit
        dataHour.exit.total++; // eslint-disable-line no-plusplus
        if (dataHour.exit[item.line]) {
          dataHour.exit[item.line]++; // eslint-disable-line no-plusplus
        } else {
          dataHour.exit[item.line] = 1;
        }
      }

      result[hour] = dataHour;
    });

    // Add missing hours
    for (let i = 0; i < 24; i++) {
      const item = result[i];
      if (!item) {
        result[i] = { hour: i, entry: { total: 0 }, exit: { total: 0 } };
      }
    }

    // Transform object from array and remove strings keys
    return Object.entries(result)
      .flatMap((v) => v)
      .filter((v) => typeof v === 'object');
  }

  // filter by day
  static filterByDay(entries: EntriesInterface[], day: number) {
    const filtered = entries.filter(
      (item) => new Date(item.usedAt).getDay() === day,
    );
    return filtered.flat(Infinity);
  }

  // format data from table
  static formatData(data: EntriesFormatedInterface[]) {
    const lines: any = [];
    let totalEntry = 0;
    let totalExit = 0;

    data.forEach((element) => {
      // entry processing
      Object.entries(element.entry).forEach(([key, value]) => {
        const index = lines.findIndex((ln: any) => ln.line === key);
        if (key === 'total') totalEntry += value;
        else if (index !== -1) {
          lines[index] = {
            ...lines[index],
            hour: element.hour,
            entry: lines[index].entry + value,
          };
        } else {
          lines.push({ hour: element.hour, line: key, entry: value, exit: 0 });
        }
      });

      // exit processing
      Object.entries(element.exit).forEach(([key, value]) => {
        const index = lines.findIndex((ln: any) => ln.line === key);
        if (key === 'total') totalExit += value;
        else if (index !== -1) {
          lines[index] = {
            ...lines[index],
            hour: element.hour,
            exit: lines[index].exit + value,
          };
        } else {
          lines.push({ hour: element.hour, line: key, exit: value, entry: 0 });
        }
      });
    });

    return { lines, totalEntry, totalExit };
  }

  static getColors(data: EntriesInterface[]) {
    const result: any = {};
    data.forEach((item) => {
      result[item.line] = item.lineColor;
    });

    return result;
  }

  static mapColors(colors: any, columns: string[]) {
    const result: any = [];
    if (columns && columns.length) {
      for (var column of columns){
        if(colors[column]){
          result.push(colors[column]);
        }
      }
    }

    return result;
  }

  static mapDataToChartData(data: any[], type: string) {
    const finalData = [];

    const lines = [''];

    // Insert all the lines
    /* eslint-disable */
    for (const item of data) {
      const entry = item[type];
      if (entry) {
        for (const key of Object.keys(entry)) {
          if (!lines.includes(key) && key !== 'total') {
            lines.push(key);
          }
        }
      }
    }

    finalData.push(lines);

    if (lines.length <= 1) {
      return [];
    }

    // Insert all the values
    for (let i = 0; i < 24; i++) {
      const item = data.find((item) => item.hour === i);
      if (item) {
        const values = [`${i}h`];
        for (let j = 1; j < lines.length; j++) {
          values.push(item.entry[lines[j]] || 0);
        }
        finalData.push(values);
      } else {
        const values = [`${i}h`];
        for (let j = 1; j < lines.length; j++) {
          values.push(item.entry[lines[j]] || 0);
        }
        finalData.push(values);
      }
    }

    return finalData;
  }
}

export default generateGraphData;
